<template>
  <div class="footer-container">
    <div>版权所有：{{ library.copyright }}</div>
    <div style="margin-left: 48px;">技术支持：{{ library.techSupport }}</div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['library'])
  }
}
</script>
<style lang="less" scoped>
@import "~@/styles/variables.less";
  @import '~@/styles/variables.less';
  .footer-container {
    width: 1920px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4D4030;
    color: white;
    font-size: 1.1rem;
  }
</style>
